import './style.less';
import * as React from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { ICompanyResponse } from '@telstra-connect/channel-care/state/company-multi-cidn';
import Select from '@able/react/dist/Select';

interface ICompanyDropDownProps {
    companyData?: ICompanyResponse;
    selectedCompanyId?: string;
    companyOptionClickHandler?: (event) => void | undefined;
    showUpliftedDropdown?: boolean;
}
const ShowCompanyDropdown = (props: ICompanyDropDownProps) => {
    const getOption = () => {
        const options = [];
        props.companyData.data.forEach((item) => {
            options.push({
                displayText: item.name,
                itemId: item.cidn,
                optionId: item.cidn,
                selectable: true,
            });
        });
        return options;
    };
    const getCidnDropdownOptions = () => {
        const options = [];
        props.companyData.data.forEach((item) => {
            options.push({
                label: item.name,
                value: item.cidn
            });
        });
        return options;
    };

    const selectedCompanyArr = props.companyData?.data?.find((item) => item.cidn === props.selectedCompanyId);
    const selectedCompanyName = selectedCompanyArr && selectedCompanyArr.name;

    return (
        props.showUpliftedDropdown ?
            <Select
                label="Company"
                options={getCidnDropdownOptions()}
                id="company-dropdown"
                size="Auto"
                defaultValue={selectedCompanyArr && selectedCompanyArr.cidn}
                disableFirstOption={true}
                events={{
                    onChange: (e) => {
                        props?.companyOptionClickHandler({ currentTarget: { id: e.target.value } })
                    }
                }}
            /> :
            <div className="tc-cc-company-container">
                <div className="tc-cc-company-text ui-company-text">Company :</div>
                <div className="tc-cc-company-dropdown">
                    <Dropdown
                        dropdownId="companyMultiCidnId"
                        searchBox={false}
                        value={selectedCompanyName}
                        options={getOption()}
                        onOptionClick={props.companyOptionClickHandler}
                        forceOpenToward={'down'}
                        optionClassName="tc-cc-company-dropdown-option"
                        className="tc-cc-company-input"
                    />
                </div>
            </div>
    );
};
export default ShowCompanyDropdown;
